// Zelfde normalisatie als backend/utils/btw.js: spaties/punten weg, hoofdletters,
// ontbrekende "NL" aanvullen. Alleen Nederlandse nummers.
export const normalizeBtw = (value) => {
  if (value === undefined || value === null) return value
  let v = String(value).replace(/[\s.\-]/g, '').toUpperCase()
  if (/^\d{9}B\d{2}$/.test(v)) v = 'NL' + v
  return v
}

export const BTW_REGEX = /^NL\d{9}B\d{2}$/
export const isValidBtw = (value) => BTW_REGEX.test(normalizeBtw(value) || '')
